// extracted by mini-css-extract-plugin
module.exports = {"section":"Tabs_section__zEaz1"};